import * as types from "./types";
/*******************
@purpose : Set UI Key on Redux
@Parameter : {key, data}
@Author : INIC
******************/
export const setUiKey = (key, data) => ({
  type: types.SET_UI_KEY,
  key,
  data,
});
/*******************
@purpose : Set Alert Notification
@Parameter : {text, level, timeout}
@Author : INIC
******************/
export const setAlert = (text, level = "success", timeout = 5000) => ({
  type: types.SHOW_ALERT,
  text,
  level,
  timeout,
});
/*******************
@purpose : Remove Alert Notification
@Parameter : {}
@Author : INIC
******************/
export const removeAlert = () => ({
  type: types.REMOVE_ALERT,
});
/*******************
@purpose :  Handle Modal View
@Parameter : {value, key}
@Author : INIC
******************/
export const toggleModal = (value, key) => ({
  type: types.TOGGLE_MODAL,
  value,
  key,
});
/*******************
@purpose :  Handle Loader View
@Parameter : {key,value}
@Author : INIC
******************/
export const toggleLoader = (key, value) => ({
  type: types.TOGGLE_LOADER,
  key,
  value,
});

export const buttonLoader = (key, value) => ({
  type: types.BUTTON_LOADER,
  key,
  value,
});

export const setShowDocumentHideProfile = (data) => ({
  type: types.SHOW_DOCUMENT_HIDE_PROFILE,
  data,
});

export const setShowEditProfileHideShowProfile = (data) => ({
  type: types.SHOW_EDIT_PROFILE_HIDE_SHOW_PROFILE,
  data,
});

export const setShowPaymentHideShowProfile = (data) => ({
  type: types.SHOW_PAYMENT_HIDE_SHOW_PROFILE,
  data,
});

export const showSuccessPopup = (text, isError = false, status = true,) => {
  return {
    type: types.SHOW_SUCESSS_POPUP,
    text: text,
    show: status,
    isError: isError
  };
};

export const setActiveTab = (tab) => {
  return {
    type: types.SET_ACTIVE_TAB,
    data: tab
  }
}

export const setShowOtpBlock = (tab) => {
  return {
    type: types.SET_SHOW_OTP_BLOCK,
    data: tab
  }
}
